import * as angular from "angular";
import { reportsTab } from "../reports-tab";
import template from "./view-export-reports-tab.html";
import type { ModalTabItem } from "../../../../components/modals/tabbed-modal/tabbed-modal-types";

export interface ViewExportReportsTabController {
	exportLog?: unknown;
}

// eslint-disable-next-line no-redeclare
export class ViewExportReportsTabController {
	public readonly tab: ModalTabItem = {
		name: "Reports",
		code: "REPORTS"
	};
}

export default angular
	.module("vesl.components.exports.view-export.tabs.reports", [reportsTab])
	.component("viewExportReportsTab", {
		controller: ViewExportReportsTabController,
		template,
		bindings: {
			exportLog: "<"
		}
	})
	.name;
